import { Navigate } from "react-router-dom";
import { AuthStatus } from "@/services/api";
import { EnterPinForm } from "@/entities/enter-pin";
import { PinCodeForm } from "@/entities/pin-code-form";
import { appRouterPaths } from "@/services/navigation";
import { Blocked } from "@/entities/blocked";
import { FlowType, PaymentForm } from "../../payment-form";
import { useCheckStatus } from "../model";

export const CheckStatusContent = () => {
  const { state, methods } = useCheckStatus();

  const { authStatus, pinFetching } = state;
  const { handleCreatePin } = methods;

  const getContent = () => {
    switch (authStatus) {
      case AuthStatus.WAIT_PIN:
        return <EnterPinForm />;
      case AuthStatus.WAIT_INITIATE:
        return <PinCodeForm onSubmit={handleCreatePin} loading={pinFetching} />;
      case AuthStatus.REGISTERED:
        return <PaymentForm flowType={FlowType.UPDATE_SUBSCRIPTION} />;
      case AuthStatus.ACTIVE:
      case AuthStatus.READONLY:
        return <Navigate to={appRouterPaths.dashboards} replace />;
      case AuthStatus.BLOCKED:
        return <Blocked type="blocked" />;
      case AuthStatus.ON_PREMISE:
      case AuthStatus.ON_PREMISE_ACTIVE:
        return <Blocked type="on-prem-active" />;
      case AuthStatus.ON_SAAS_ACTIVE:
        return <Blocked type="on-saas-active" />;
      case AuthStatus.UNDEFINED_TYPE:
        return <Blocked type="on-prem" />;
      case AuthStatus.UNKNOWN:
        return <Blocked type="unknown" />;
      case AuthStatus.EXPIRED:
        return <Blocked type="expired" />;

      default:
        return <Navigate to={appRouterPaths.logIn} replace />;
    }
  };

  return getContent();
};
